"use client";

import { useState } from "react";
import { SelectionChip } from "../SelectionChip";

const OPTIONS = [
  "Lost in a text thread.",
  "Stuck in a professional chat channel.",
  "Floating in the air after saying it.",
  "Nowhere. It stayed in my head.",
] as const;

type Screen2QuestionProps = {
  onNext: () => void;
};

export function Screen2Question({ onNext }: Screen2QuestionProps) {
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (value: string) => {
    setSelected(value);
    window.setTimeout(onNext, 500);
  };

  return (
    <div className="flex flex-1 flex-col">
      <div className="mb-10">
        <p
          className="mb-6 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground animate-fade-in-up"
        >
          § 002 — Question
        </p>
        <h1
          className="text-[2rem] leading-[1.15] text-foreground animate-fade-in-up"
          style={{ animationDelay: "0.1s", opacity: 0 }}
        >
          Most recognition gets buried somewhere. Where does yours usually go to
          die?
        </h1>
      </div>
      <div className="flex flex-col gap-3">
        {OPTIONS.map((opt, index) => (
          <div
            key={opt}
            className="animate-fade-in-up"
            style={{
              animationDelay: `${(index + 2) * 0.1}s`,
              opacity: 0,
            }}
          >
            <SelectionChip
              selected={selected === opt}
              onClick={() => handleSelect(opt)}
            >
              {opt}
            </SelectionChip>
          </div>
        ))}
      </div>
    </div>
  );
}
